import { useEffect } from "react";
import { useRoleStore } from "@/store/useRoleStore";

export function useRole() {
  const { role, isAdmin, roleCheck, fetchRole } = useRoleStore();

  useEffect(() => {
    if (!roleCheck) {
      fetchRole();
    }
  }, [roleCheck, fetchRole]);

  return { role, isAdmin, roleCheck, fetchRole };
}
